export default __webpack_public_path__ + "app/images/theme-images/dark/emoji-picker/icon-20-emoji@2x.webp";